import React, { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import '../style/peri-check.css'
import { useTranslation } from "react-i18next";
import LogoEn from '../../../assets/vietnam/logo-en.png';
import english from "../../../assets/periGum/signal1_optimized.png";
import { generateRandomAlphaNumeric } from "../../../Utils/alphaNumeric";
import { postLogDetails } from "../../../Services/APIs/appDetails";
import { useSelector } from "react-redux";

const LandingPage2 = () => {

    const { t, i18n } = useTranslation("l2")
  const [showLangSelect, setShowLangSelect] = useState(true);
  const storedUid = localStorage.getItem("usertpi")
    const initialId = storedUid ? JSON.parse(storedUid).usertpi : ''
        const [uid, setUid] = useState(initialId)
    const { images } = useSelector((state) => state.fullScan);
    const navigate = useNavigate();

// --------------------------------------------
    
    localStorage.setItem("companyBucket", JSON.stringify({ companyBucket: "signal-en" }));
    localStorage.setItem("isAutomated", true)
    // localStorage.removeItem("scanType");
    // localStorage.setItem("i18nextLng","en")
    // localStorage.setItem("userLanguage", "en")
    useEffect(() => {
        // Clear localStorage if isScanCompleted is true
        if (localStorage.getItem("isScanCompleted") === "true") {
            localStorage.clear();
        }
        // setTimeout(() => {
        //     moveToPage2()
        // }, 3500);
        // console.log("reloaded",localStorage.getItem("reloaded"))
    const reloaded = localStorage.getItem("reloaded");
    if(reloaded === "false" || reloaded === null) reload()
        if (!uid || images.length === 0) {
            generateInfo()
        }

        return(()=>{
            localStorage.setItem("reloaded", false)
        })
    }, [])
    

 const reload = () => {
        localStorage.clear();
        localStorage.setItem("reloaded", true)

        window.location.reload()
    }

    const generateInfo = () => {
        const randomString = generateRandomAlphaNumeric(2);
        const timestamp = Date.now().toString();
        const randomString2 = generateRandomAlphaNumeric(1)
        const unique = randomString + timestamp + randomString2
        localStorage.setItem("usertpi", JSON.stringify({ usertpi: unique }));
        localStorage.setItem("companyBucket", JSON.stringify({ companyBucket: "signal-en" }));
        setUid(unique)
        postLogDetails({ uid: unique, app: `signal-${i18n.language}`, payLoad: `visited landing page` })
    }



// --------------------------------------------
    // useEffect(() => {
    //     setTimeout(() => {
    //         navigate('/peri-gum/landing-page-2')
    //     }, 3500)
    // })

      const handleLanguageSelect = (lang) => {
        setShowLangSelect(false);
        if (lang === 'en') {
            localStorage.setItem("userLanguage", "en");
            i18n.changeLanguage("en");
            localStorage.setItem("companyBucket", JSON.stringify({ companyBucket: "signal-en" }));
            navigate('/expert/en');
        } else {
            localStorage.setItem("userLanguage", "ab");
            i18n.changeLanguage("ab");
            localStorage.setItem("companyBucket", JSON.stringify({ companyBucket: "signal-ab" }));
            navigate('/expert/ab');
        }
    };

    return (
        <div className="relative w-full h-full landing-page2-container">
             <div className="flex justify-center py-10">
              
                    <img
                        src={english}
                        alt="Signal Expert"
                        className="w-32 max-h-20 object-contain"
                    />
            </div>
            <div className="flex justify-center flex-col  m-auto w-[85%] max-w-md">
                <div>
                    <h1
                        className={`font-cera-pro-black text-peri-secondary ${i18n.language === 'vn'
                            ? 'text-[38px] mb-6 leading-[40px]'
                            : 'text-[55px] mb-4 leading-[45px]'
                            }`}
                    >
                        {t("header").split("\n").map((line, index) => (
                            <span key={index}>
                                {line}
                                <br />
                            </span>
                        ))}
                    </h1>
                </div>

                <div className=" p-8 rounded-2xl shadow-lg flex flex-col items-center">
                    <h2 className="text-2xl font-bold mb-6 text-peri-primary">Select Language</h2>
                    <div className="flex space-x-6">
                        <button
                            className="px-6 py-3 bg-peri-primary text-white rounded-lg font-semibold text-lg hover:bg-peri-pink transition-colors"
                            onClick={() => handleLanguageSelect('en')}
                        >
                            English
                        </button>
                        <button
                            className="px-6 py-3 bg-peri-pink text-white rounded-lg font-semibold text-lg hover:bg-peri-primary transition-colors"
                            onClick={() => handleLanguageSelect('ab')}
                        >
                            العربية
                        </button>
                    </div>
                </div>
            

                <p className={`text-peri-secondary font-cera-pro-medium text-[14px] mt-2 ${i18n.language === 'vn' ? `font-[500]` : `font-[600]`}`}>

                    {t("footer").split('\n').map((line, idx) => (
                        <span key={idx}>
                            {line}
                            <br />
                        </span>
                    ))}
                </p>

                 <div className="w-full bg-black bg-opacity-40 mt-12 p-4">
                    <p className="text-center mb-2 text-white font-cera-pro-light">
                        {t("logo")}
                    </p>
                    <div className="w-full flex justify-center my-3">
                     
                        
                             
                                <img
                                    src={LogoEn}
                                    alt="company logos"
                                    className="w-64 object-contain"

                                />
                        
                    </div>
                </div>


            </div>
        </div>
    );
};

export default LandingPage2;
